<template>
  <div>
    <b-modal
      v-model="isShow"
      id="modal-1"
      @ok="save"
      title="Nhập lý do bỏ duyệt dịch vụ"
    >
      <el-form
        :model="mData.dataForm"
        :rules="mData.validForm"
        ref="myForm"
        label-width="100%"
        label-position="top"
      >
        <b-row>
          <b-col md="12">
            <el-form-item label="Lý do" prop="ly_do_tu_choi">
              <el-input
                type="textarea"
                :rows="2"
                v-model="mData.dataForm.ly_do_tu_choi"
                clearable
              ></el-input>
            </el-form-item>
          </b-col>
        </b-row>
      </el-form>
    </b-modal>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import VuiChoiGiaiTriModel from "./VuiChoiGiaiTriModel";
import DichVuChoDuyetApi from "@/moduleApi/DichVuChoDuyetApi";
import mushroom from "@/service/api/trangvang-api";
export default {
  props: ["isShow", "dataObject"],
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "VuiChoiGiaiTri",
        currentUser: JSON.parse(localStorage.getItem("currentUser")),
        dataDefault: {
          listProvince: [],
        },
        dataForm: MethodService.copyObject(VuiChoiGiaiTriModel.dataForm),
        fileUploadOption: MethodService.copyObject(
          VuiChoiGiaiTriModel.dataFormOther.fileUploadOption
        ),
        validForm: VuiChoiGiaiTriModel.validForm,
      },
    };
  },
  methods: {
    async save() {
      let data = this.dataObject;
      try {
        const response =
          await mushroom.tv_dich_vu_cho_duyet.approvedDichVuAsync({
            body: {
              id: data.id,
              duyet: {
                duoc_duyet: false,
              },
              ly_do_tu_choi: this.mData.dataForm.ly_do_tu_choi || null,
            },
          });

        console.log("Dữ liệu trả về, response: %o", response);
        // Kết quả: response.result
        // Metadata: response.meta

        this.fn_go();
        this.$store.commit("fn_countDiemDen");
        this.$store.commit("fn_countLuuTru");
        this.$store.commit("fn_countAmThuc");
        this.$store.commit("fn_countGiaiTri");
        this.$store.commit("fn_countVeDienTu");
      } catch (error) {
        MethodService.stopLadda();
        console.error("Có lỗi: %o", error);
      }
    },
    fn_go() {
      this.$router.go(-1);
    },
  },
};
</script>
